export const CancelIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd" transform="translate(2 2)">
        <g fill="#ADADAD" mask="url(#b)">
          <path
            id="a"
            d="M10 0C4.47 0 0 4.47 0 10s4.47 10 10 10 10-4.47 10-10S15.53 0 10 0zm5 13.59L13.59 15 10 11.41 6.41 15 5 13.59 8.59 10 5 6.41 6.41 5 10 8.59 13.59 5 15 6.41 11.41 10 15 13.59z"
          />
        </g>
      </g>
    </svg>
  );
};
